import React, {useEffect} from 'react'
import {makeStyles} from "@material-ui/core/styles";
import MetasMainView from "./MetasMainView";

const useStyles = makeStyles(theme => ({

}));


export interface iMeta {
    id?: number,
    descricao: string,
    ano: number,
    mes: number,
    diasUteis?: number,
    metaCategoriaId: number,
    estabelecimentoId: number,
    turno: number,
    objetivo: number
}


const Metas = ( props   ) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <MetasMainView />
        </React.Fragment>
    )
}

export default  (Metas);

